var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "section" },
    [
      _c("div", { staticClass: "container" }, [
        _c(
          "div",
          { staticClass: "level" },
          [
            _c(
              "Header",
              _vm._b(
                { staticClass: "level-left" },
                "Header",
                _vm.$route.meta,
                false
              )
            ),
            _c(
              "b-button",
              {
                staticClass: "left-right",
                attrs: { type: "is-success", "icon-left": "plus" },
                on: {
                  click: function ($event) {
                    return _vm.showCreateForm()
                  },
                },
              },
              [_vm._v(" New Forecast ")]
            ),
          ],
          1
        ),
        _c("div", { staticClass: "columns" }, [
          _c(
            "div",
            { staticClass: "column" },
            [
              _c(
                "b-field",
                { attrs: { grouped: "" } },
                [
                  _c(
                    "b-field",
                    {
                      attrs: {
                        label: _vm.$t("pages.customer_forecast.continent"),
                      },
                    },
                    [
                      _c("multiselect", {
                        staticStyle: { "min-width": "400px" },
                        attrs: {
                          options: _vm.continents,
                          multiple: true,
                          "close-on-select": true,
                          placeholder: "Continent",
                        },
                        on: {
                          select: function ($event) {
                            return _vm.continentSelected()
                          },
                          remove: function ($event) {
                            return _vm.continentRemoved()
                          },
                        },
                        model: {
                          value: _vm.continentFilter,
                          callback: function ($$v) {
                            _vm.continentFilter = $$v
                          },
                          expression: "continentFilter",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-field",
                { attrs: { grouped: "" } },
                [
                  _c(
                    "b-field",
                    {
                      attrs: {
                        label: _vm.$t("pages.customer_forecast.country"),
                      },
                    },
                    [
                      _c("multiselect", {
                        staticStyle: { "min-width": "400px" },
                        attrs: {
                          options: _vm.filteredCountries,
                          multiple: true,
                          "close-on-select": true,
                          placeholder: "Country",
                          "custom-label": (obj) => obj.name,
                          "track-by": "code",
                        },
                        on: {
                          select: function ($event) {
                            return _vm.countrySelected()
                          },
                          remove: function ($event) {
                            return _vm.countryRemoved()
                          },
                        },
                        model: {
                          value: _vm.countryFilter,
                          callback: function ($$v) {
                            _vm.countryFilter = $$v
                          },
                          expression: "countryFilter",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-field",
                { attrs: { grouped: "" } },
                [
                  _c(
                    "b-field",
                    {
                      attrs: {
                        label: _vm.$t("pages.customer_forecast.sold_to_filter"),
                      },
                    },
                    [
                      _c("multiselect", {
                        staticStyle: { "min-width": "400px" },
                        attrs: {
                          options: _vm.sold_to_filter_options,
                          multiple: true,
                          "close-on-select": true,
                          placeholder: "Sold To",
                          "custom-label": (obj) =>
                            obj.sold_to + " - " + obj.sold_to_name,
                          "track-by": "sold_to",
                        },
                        on: {
                          select: function ($event) {
                            return _vm.soldToFilterSelected()
                          },
                          remove: function ($event) {
                            return _vm.soldToFilterRemoved()
                          },
                        },
                        model: {
                          value: _vm.sold_to_filter,
                          callback: function ($$v) {
                            _vm.sold_to_filter = $$v
                          },
                          expression: "sold_to_filter",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-field",
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "left-right",
                      attrs: {
                        type: "is-warning",
                        "icon-left": "arrows-rotate",
                        disabled: _vm.isLoading,
                      },
                      on: {
                        click: () => {
                          _vm.resetData()
                          _vm.getData()
                        },
                      },
                    },
                    [_vm._v(" Load ")]
                  ),
                  _c(
                    "b-button",
                    {
                      staticClass: "ml-3",
                      attrs: { type: "is-success", "icon-left": "upload" },
                      on: {
                        click: () => {
                          _vm.isImportingExcel = true
                        },
                      },
                    },
                    [_vm._v(" Import xlsx ")]
                  ),
                ],
                1
              ),
              _vm.forecasts.length != 0
                ? _c("ag-grid-vue", {
                    staticClass: "ag-theme-balham",
                    staticStyle: { width: "100%", height: "700px" },
                    attrs: {
                      "row-data": _vm.forecasts,
                      "grid-options": _vm.gridOptions,
                      pagination: true,
                      "pagination-auto-page-size": true,
                      "cache-overflow-size": 0,
                      "multi-sort-key": "ctrl",
                      modules: _vm.modules,
                      "get-context-menu-items": _vm.getContextMenuItems,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ]),
      ]),
      _c(
        "b-modal",
        {
          attrs: {
            active: _vm.isCreatingForecast,
            scroll: "keep",
            "has-modal-card": "",
          },
          on: {
            "update:active": function ($event) {
              _vm.isCreatingForecast = $event
            },
          },
        },
        [
          _vm.isCreatingForecast
            ? _c(
                "form",
                {
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.submitForecast.apply(null, arguments)
                    },
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "modal-card",
                      staticStyle: {
                        "min-width": "50vw",
                        width: "fit-content",
                        "min-height": "50vh",
                        height: "fit-content",
                      },
                    },
                    [
                      _c("header", { staticClass: "modal-card-head" }, [
                        _c("p", { staticClass: "modal-card-title" }, [
                          _vm._v(" Create Forecast "),
                        ]),
                      ]),
                      _c(
                        "section",
                        { staticClass: "modal-card-body" },
                        [
                          _c(
                            "b-field",
                            { attrs: { grouped: "" } },
                            [
                              _c(
                                "b-field",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "pages.customer_forecast.delivery_date"
                                    ),
                                  },
                                },
                                [
                                  _c("b-datepicker", {
                                    attrs: {
                                      name: "newdeliverydate",
                                      "first-day-of-week": 1,
                                      locale: "en-CA",
                                      icon: "calendar-alt",
                                    },
                                    model: {
                                      value: _vm.newForecast.delivery_date,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.newForecast,
                                          "delivery_date",
                                          $$v
                                        )
                                      },
                                      expression: "newForecast.delivery_date",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "b-field",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "pages.customer_forecast.reception_date"
                                    ),
                                  },
                                },
                                [
                                  _c("b-datepicker", {
                                    attrs: {
                                      name: "newreceptiondate",
                                      "first-day-of-week": 1,
                                      locale: "en-CA",
                                      icon: "calendar-alt",
                                    },
                                    model: {
                                      value: _vm.newForecast.reception_date,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.newForecast,
                                          "reception_date",
                                          $$v
                                        )
                                      },
                                      expression: "newForecast.reception_date",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-field",
                            [
                              _c(
                                "b-button",
                                {
                                  attrs: {
                                    type: _vm.goingShipTo ? "is-success" : "",
                                    disabled: !_vm.soldToSelected,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.chooseStart("SHIP")
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "pages.customer_forecast.add_ship_to"
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                              _c(
                                "b-button",
                                {
                                  attrs: {
                                    type: _vm.goingPort ? "is-success" : "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.chooseStart("PORT")
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "pages.customer_forecast.add_port"
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-field",
                            { attrs: { label: "Sold To" } },
                            [
                              _c("multiselect", {
                                staticStyle: { "min-width": "400px" },
                                attrs: {
                                  options: _vm.soldTos,
                                  multiple: false,
                                  "close-on-select": true,
                                  placeholder: "Pick customer",
                                  "custom-label": (obj) =>
                                    obj.sold_to + " - " + obj.sold_to_name,
                                  "track-by": "sold_to",
                                },
                                on: {
                                  select: () => {
                                    _vm.soldToSelected = true
                                  },
                                },
                                model: {
                                  value: _vm.newForecast.sold_to_object,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.newForecast,
                                      "sold_to_object",
                                      $$v
                                    )
                                  },
                                  expression: "newForecast.sold_to_object",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm.soldToSelected
                            ? _c(
                                "div",
                                [
                                  _vm.newForecast.sold_to_object.sold_to_alt &&
                                  _vm.newForecast.sold_to_object.sold_to_alt !=
                                    ""
                                    ? _c(
                                        "b-field",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "pages.customer_forecast.sold_to_alt"
                                            ),
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.newForecast.sold_to_object
                                                  .sold_to_alt
                                              ) +
                                              " "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.goingShipTo
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "b-field",
                                    { attrs: { label: "Ship To" } },
                                    [
                                      _c("multiselect", {
                                        staticStyle: { "min-width": "400px" },
                                        attrs: {
                                          options: _vm.shipTos,
                                          multiple: false,
                                          "close-on-select": true,
                                          placeholder: "Pick Ship To",
                                          "custom-label": (obj) =>
                                            obj.ship_to +
                                            " - " +
                                            obj.ship_to_name,
                                          "track-by": "ship_to",
                                        },
                                        on: {
                                          select: () => {
                                            _vm.shipToSelected = true
                                          },
                                        },
                                        model: {
                                          value: _vm.newForecast.ship_to_object,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.newForecast,
                                              "ship_to_object",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "newForecast.ship_to_object",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm.shipToSelected
                                    ? _c(
                                        "div",
                                        [
                                          _vm.newForecast.ship_to_object
                                            .ship_to_alt &&
                                          _vm.newForecast.ship_to_object
                                            .ship_to_alt != ""
                                            ? _c(
                                                "b-field",
                                                {
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "pages.customer_forecast.ship_to_alt"
                                                    ),
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.newForecast
                                                          .ship_to_object
                                                          .ship_to_alt
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.goingPort
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "b-field",
                                    { attrs: { label: "Port" } },
                                    [
                                      _c("multiselect", {
                                        staticStyle: { "min-width": "400px" },
                                        attrs: {
                                          options: _vm.ports,
                                          multiple: false,
                                          "close-on-select": true,
                                          placeholder: "Pick Port",
                                          "custom-label": (obj) => obj.name,
                                          "track-by": "name",
                                        },
                                        model: {
                                          value: _vm.newForecast.port,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.newForecast,
                                              "port",
                                              $$v
                                            )
                                          },
                                          expression: "newForecast.port",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "b-field",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "pages.customer_forecast.quantity"
                                ),
                              },
                            },
                            [
                              _c("b-input", {
                                attrs: { type: "number" },
                                model: {
                                  value: _vm.newForecast.quantity,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.newForecast, "quantity", $$v)
                                  },
                                  expression: "newForecast.quantity",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-field",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "pages.customer_forecast.material"
                                ),
                              },
                            },
                            [
                              _c(
                                "b-select",
                                {
                                  model: {
                                    value: _vm.newForecast.material,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.newForecast, "material", $$v)
                                    },
                                    expression: "newForecast.material",
                                  },
                                },
                                [
                                  _c("option", { attrs: { value: "5.2" } }, [
                                    _vm._v(" 5.2 "),
                                  ]),
                                  _c("option", { attrs: { value: "5.5" } }, [
                                    _vm._v(" 5.5 "),
                                  ]),
                                  _c("option", { attrs: { value: "5.1" } }, [
                                    _vm._v(" 5.1 "),
                                  ]),
                                  _c("option", { attrs: { value: "1" } }, [
                                    _vm._v(" 1 "),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("footer", { staticClass: "modal-card-foot" }, [
                        _c(
                          "button",
                          {
                            staticClass: "button is-info is-fullwidth",
                            attrs: { type: "submit" },
                          },
                          [_vm._v(" " + _vm._s(_vm.$t("global.submit")) + " ")]
                        ),
                      ]),
                    ]
                  ),
                ]
              )
            : _vm._e(),
        ]
      ),
      _c(
        "b-modal",
        {
          attrs: {
            active: _vm.isImportingExcel,
            scroll: "keep",
            "has-modal-card": "",
          },
          on: {
            "update:active": function ($event) {
              _vm.isImportingExcel = $event
            },
          },
        },
        [
          _vm.isImportingExcel
            ? _c("div", { staticStyle: { "margin-left": "-20vw" } }, [
                _c(
                  "div",
                  {
                    staticClass: "modal-card",
                    staticStyle: {
                      "min-width": "70vw",
                      width: "fit-content",
                      "min-height": "50vh",
                      height: "fit-content",
                    },
                  },
                  [
                    _c("header", { staticClass: "modal-card-head" }, [
                      _c("p", { staticClass: "modal-card-title" }, [
                        _vm._v(" Import Excel Simulations "),
                      ]),
                    ]),
                    _c(
                      "section",
                      { staticClass: "modal-card-body" },
                      [
                        _c(
                          "b-field",
                          { attrs: { grouped: "" } },
                          [
                            _c(
                              "b-field",
                              [
                                _c("input", {
                                  attrs: {
                                    id: "fileUpload",
                                    type: "file",
                                    accept:
                                      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                                    hidden: "",
                                  },
                                  on: { change: _vm.loadFile },
                                }),
                                _c(
                                  "b-button",
                                  {
                                    staticClass: "btn",
                                    on: { click: _vm.chooseFiles },
                                  },
                                  [_vm._v(" Choose File ")]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "b-field",
                              [
                                _c(
                                  "b-button",
                                  {
                                    staticClass: "left-right",
                                    attrs: {
                                      type: "is-warning",
                                      "icon-left": "x",
                                      disabled: !_vm.loadedExcel,
                                    },
                                    on: {
                                      click: () => {
                                        _vm.testExcel()
                                      },
                                    },
                                  },
                                  [_vm._v(" Read Simulations ")]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "b-field",
                              [
                                _c(
                                  "b-button",
                                  {
                                    staticClass: "left-right",
                                    attrs: {
                                      type: "is-warning",
                                      "icon-left": "x",
                                      disabled:
                                        _vm.importedForecasts.length <= 0,
                                    },
                                    on: {
                                      click: () => {
                                        _vm.saveForecasts()
                                      },
                                    },
                                  },
                                  [_vm._v(" Save Forecasts ")]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm.importedForecasts &&
                        _vm.importedForecasts.length > 0
                          ? _c(
                              "div",
                              {
                                staticStyle: {
                                  "margin-top": "5px",
                                  "margin-bottom": "20px",
                                  "overflow-x": "auto",
                                },
                              },
                              [
                                _c(
                                  "table",
                                  {
                                    staticClass:
                                      "table is-striped is-bordered is-narrow is-fullwidth",
                                  },
                                  [
                                    _c("thead", [
                                      _c("tr", [
                                        _c("th", [_vm._v("Sold To Name")]),
                                        _c("th", [_vm._v("Ship To Name")]),
                                        _c("th", [_vm._v("Material")]),
                                        _c("th", [_vm._v("Quantity")]),
                                        _c("th", [_vm._v("Port")]),
                                        _c("th", [_vm._v("Delivery Date")]),
                                        _c("th", [_vm._v("Reception Date")]),
                                        _c("th", [_vm._v("Sold To Alt")]),
                                        _c("th", [_vm._v("Ship To Region")]),
                                        _c("th", [_vm._v("Sold To")]),
                                        _c("th", [_vm._v("Ship To")]),
                                        _c("th", [_vm._v("Ship To Alt")]),
                                      ]),
                                    ]),
                                    _c(
                                      "tbody",
                                      _vm._l(
                                        _vm.importedForecasts,
                                        function (importedForecast, index) {
                                          return _c(
                                            "tr",
                                            { key: "simulation" + index },
                                            [
                                              _c("td", [
                                                _vm._v(
                                                  _vm._s(
                                                    importedForecast.sold_to_name
                                                  )
                                                ),
                                              ]),
                                              _c("td", [
                                                _vm._v(
                                                  _vm._s(
                                                    importedForecast.ship_to_name
                                                  )
                                                ),
                                              ]),
                                              _c("td", [
                                                _vm._v(
                                                  _vm._s(
                                                    importedForecast.material
                                                  )
                                                ),
                                              ]),
                                              _c("td", [
                                                _vm._v(
                                                  _vm._s(
                                                    importedForecast.quantity
                                                  )
                                                ),
                                              ]),
                                              _c("td", [
                                                _vm._v(
                                                  _vm._s(importedForecast.port)
                                                ),
                                              ]),
                                              _c("td", [
                                                _vm._v(
                                                  _vm._s(
                                                    new Date(
                                                      importedForecast.delivery_date
                                                    ).toLocaleDateString(
                                                      "en-CA"
                                                    )
                                                  )
                                                ),
                                              ]),
                                              _c("td", [
                                                _vm._v(
                                                  _vm._s(
                                                    new Date(
                                                      importedForecast.reception_date
                                                    ).toLocaleDateString(
                                                      "en-CA"
                                                    )
                                                  )
                                                ),
                                              ]),
                                              _c("td", [
                                                _vm._v(
                                                  _vm._s(
                                                    importedForecast.sold_to_alt
                                                  )
                                                ),
                                              ]),
                                              _c("td", [
                                                _vm._v(
                                                  _vm._s(
                                                    importedForecast.ship_to_region
                                                  )
                                                ),
                                              ]),
                                              _c("td", [
                                                _vm._v(
                                                  _vm._s(
                                                    importedForecast.sold_to
                                                  )
                                                ),
                                              ]),
                                              _c("td", [
                                                _vm._v(
                                                  _vm._s(
                                                    importedForecast.ship_to
                                                  )
                                                ),
                                              ]),
                                              _c("td", [
                                                _vm._v(
                                                  _vm._s(
                                                    importedForecast.ship_to_alt
                                                  )
                                                ),
                                              ]),
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]
                ),
              ])
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }